import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Task 07: OrderTicketModal — phiếu đặt lệnh qua Portal (.vnsc-root).
// Task TVP-B1: rút gọn thành wrapper mỏng quanh OrderTicketForm dùng chung
// với Dock Panel. Mọi logic/state/testids nằm trong Form (tests cũ giữ nguyên).
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { OrderTicketForm } from "./OrderTicketForm";
import styles from "./OrderTicketModal.module.css";
export function OrderTicketModal({ open, mountTarget, onClose, ...formProps }) {
    const anchorRef = useRef(null);
    const [target, setTarget] = useState(null);
    useEffect(() => {
        if (!open || typeof document === "undefined")
            return;
        // Ticket portal lên workspace root (multi) để fixed overlay phủ toàn viewport:
        // portal vào .vnsc-root của cell sẽ bị slot kẹp/đè theo DOM-order từng ô (bug 2x2).
        // Single-chart không có workspace root nên rớt về root của chính chart (giữ nguyên).
        const anchor = anchorRef.current;
        setTarget(mountTarget ?? anchor?.closest(".vnsc-multicharts-root") ?? anchor?.closest(".vnsc-root") ?? document.body);
    }, [open, mountTarget]);
    useEffect(() => {
        if (!open)
            return;
        const handleKey = (e) => {
            if (e.key === "Escape")
                onClose();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [open, onClose]);
    if (!open)
        return null;
    const dialog = (_jsx("div", { className: styles.overlay, "data-testid": "order-ticket-overlay", onClick: (e) => {
            if (e.target === e.currentTarget)
                onClose();
        }, children: _jsx(OrderTicketForm, { ...formProps, onClose: onClose }) }));
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: anchorRef, style: { display: "none" } }), target ? createPortal(dialog, target) : dialog] }));
}
